import styled from 'styled-components';
import { Grid, Card } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';

export const StyledCard = styled(Card)`
  && {
    padding: 16px 24px;
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right bottom 55%;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    height: 463px;
    width: 816px;
  }
`;
export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  line-height: 23px !important;
  text-align: justify !important;
  margin-bottom: 5px !important;
`;
export const StyledGrid = styled(Grid)`
  margin-top: 15px !important;
`;
